import { useRef } from "react";
import { Carousel } from "react-bootstrap";

import { useAttributesInjectedOffers } from "./index.js";

import { ChevronLeft, ChevronRight } from "../../Assets/Icons";

import "./deals-carousel.scss";

export default function DealsCarousel() {
  const carouselRef = useRef(null);

  const attributesInjectedOffers = useAttributesInjectedOffers();

  if (attributesInjectedOffers?.length === 0) return null;

  return (
    <div className="deals-carousel">
      <div className="deals-carousel-header">
        <h3 className="deals-carousel-title">Deals</h3>
        <div className="deals-carousel-nav">
          <button
            className="nav-button"
            onClick={() => carouselRef.current?.prev()}
            type="button"
            aria-label="Previous deal"
          >
            <ChevronLeft />
          </button>
          <button
            className="nav-button"
            onClick={() => carouselRef.current?.next()}
            type="button"
            aria-label="Next deal"
          >
            <ChevronRight />
          </button>
        </div>
      </div>
      <div className="deals-carousel-divider" />
      <Carousel ref={carouselRef} controls={false} indicators={false} interval={5000} wrap>
        {attributesInjectedOffers?.map((deal) => (
          <Carousel.Item key={deal.id}>
            <div className="deals-carousel-content">
              <div className="deals-carousel-info">
                <h4 className="deal-name">{deal.title}</h4>
                <p className="deal-description">{deal.description}</p>
                <button className="deal-cta" onClick={deal.onButtonClick} type="button">
                  {deal.resident_facing_cta}
                  <ChevronRight />
                </button>
              </div>
              <div className="deals-carousel-image">
                <img src={deal.image_link} alt={deal.title} />
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}
